import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PLAN_PATH } from "../../utils/constants/routes";
import { loadSignupState } from "../../utils/helpers/signupState";

const PaymentCancelScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Fix #4: preserve the signup context (draft_id etc.) on cancel so the user resumes the SAME
    // signup instead of restarting. signup_state is the durable store kept by the step screens.
    const persisted = loadSignupState();
    navigate(PLAN_PATH, {
      replace: true,
      state: { ...persisted, error: "Payment was cancelled. You can try again whenever you're ready." },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default PaymentCancelScreen;
